'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_sr_BooleanRef(elem) {
  this.wO = false;
  this.wO = elem;
}
export { $c_sr_BooleanRef as $c_sr_BooleanRef };
$p = $c_sr_BooleanRef.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_sr_BooleanRef;
/** @constructor */
function $h_sr_BooleanRef() {
}
export { $h_sr_BooleanRef as $h_sr_BooleanRef };
$h_sr_BooleanRef.prototype = $p;
$p.b = (function() {
  return ("" + this.wO);
});
var $d_sr_BooleanRef = new $j_java$002elang$002e$002dObject.$TypeData().i($c_sr_BooleanRef, "scala.runtime.BooleanRef", ({
  vC: 1,
  a: 1
}));
export { $d_sr_BooleanRef as $d_sr_BooleanRef };
